import {Moment} from 'moment'
import * as React from 'react'
import {ReactElement} from 'react'
import {Box} from '@mui/material'
import {DisplayItemTitle} from '../../../../../styledComponents/DisplayItem'
import {NatPostDisasterCommentRequest} from '../../repository/NatPostDisasterComment'
import {Nullable, Optional} from '../../../../../app/TypeHelpers'
import styled from 'styled-components'
import {Colors} from '../../../../../styledComponents/Constants'
import {VIEW_DO_OR_NOT} from '../../../../../CodeMaster'
import {NatPostDisasterCommentFileUploadRequest} from '../../repository/NatPostDisasterCommentFileUpload'
import NatDisasterCommentInputForm, {DisasterCommentFile} from './NatDisasterCommentInputForm'
import {BlockSpacer} from '../../../../../styledComponents/ResponsiveConvenience'
import {InputError} from './NatDisasterCommentError'
import equal from 'fast-deep-equal'

interface Props {
    condominiumCd: string
    topicId: number
    posterNamePrivateFlag: boolean
    currentDateTime: Moment
    onNewComment: (
        commentRequest: NatPostDisasterCommentRequest,
        fileRequests: NatPostDisasterCommentFileUploadRequest[]
    ) => Promise<Nullable<InputError>>
}

interface State {
    comment: string
    posterNamePrivateFlag: boolean
    newCommentFileList: DisasterCommentFile[]
    inputError: Optional<InputError>
}

export default class NatResidentDisasterNewComment extends React.PureComponent<Props, State> {
    constructor(props: Readonly<Props>) {
        super(props)
        this.state = {
            comment: '',
            posterNamePrivateFlag: this.props.posterNamePrivateFlag,
            newCommentFileList: [],
            inputError: undefined
        }

        this.handleClickRegisterReplyButton = this.handleClickRegisterReplyButton.bind(this)
    }

    componentDidUpdate(prevProps: Props): void {
        if (!equal(prevProps.posterNamePrivateFlag, this.props.posterNamePrivateFlag)) {
            this.setState({posterNamePrivateFlag: this.props.posterNamePrivateFlag})
        }
    }

    onClickReplyButton = async (
        commentRequest: NatPostDisasterCommentRequest,
        fileRequests: NatPostDisasterCommentFileUploadRequest[]
    ): Promise<Nullable<InputError>> => {
        return await this.props.onNewComment(commentRequest, fileRequests)
    }

    handleClickCloseCommentInputButton = (): void => {
        this.setState({comment: '', newCommentFileList: [], inputError: undefined})
    }

    async handleClickRegisterReplyButton(): Promise<void> {
        const {comment, posterNamePrivateFlag} = this.state

        const fileRequests: NatPostDisasterCommentFileUploadRequest[] =
            this.state.newCommentFileList.map(file => {
                const data: string[] = String(file.fileData).split(',')
                return {fileName: file.fileName, fileData: data[1]}
            })
        const commentRequest: NatPostDisasterCommentRequest = {
            replySourceId: null,
            comment: comment,
            posterNamePrivateFlag: posterNamePrivateFlag ?
                VIEW_DO_OR_NOT.HIDDEN.value : VIEW_DO_OR_NOT.DISPLAY.value,
            imageAttachedFlag: fileRequests.length === 0 ?
                VIEW_DO_OR_NOT.HIDDEN.value : VIEW_DO_OR_NOT.DISPLAY.value
        }

        const inputError = await this.onClickReplyButton(commentRequest, fileRequests)
        if (inputError && !inputError.fileNameList) {
            this.setState({inputError: inputError})
        } else {
            this.setState({comment: '', newCommentFileList: []})
        }
    }

    handleChangeCommentInput = (
        content: string,
        posterNamePrivateFlag: boolean,
        commentFileList: DisasterCommentFile[],
        deleteFileNumberList: number[],
        inputError?: InputError
    ): void => {
        this.setState({
            comment: content,
            posterNamePrivateFlag: posterNamePrivateFlag,
            newCommentFileList: [...commentFileList],
            inputError: inputError
        })
    }

    render(): ReactElement {

        return (
            <>
                <CommentArea>
                    <Box padding={'20px 15px'}>
                        <DisplayItemTitle>新規コメントを投稿する</DisplayItemTitle>
                    </Box>
                    <Box padding={'0 15px 15px 15px'}>
                        コメントには名字と部屋番号が表示されます。<br/>
                        名字は非公開にすることもできます。
                        <BlockSpacer height={'15px'}/>
                        <NatDisasterCommentInputForm
                            id={`new-comment`}
                            submitButtonLabel={`投稿する`}
                            clearButtonLabel={'クリア'}
                            onClickSubmitButton={this.handleClickRegisterReplyButton}
                            onClickCancelButton={this.handleClickCloseCommentInputButton}
                            onChange={this.handleChangeCommentInput}
                            comment={this.state.comment}
                            posterNamePrivateFlag={this.state.posterNamePrivateFlag}
                            placeholder={'新しいコメントを入力...'}
                            commentFileList={this.state.newCommentFileList}
                            deleteFileNumberList={[]}
                            inputError={this.state.inputError}
                        />
                    </Box>
                </CommentArea>
            </>
        )
    }
}

const CommentArea = styled.div`
    background-color: ${Colors.Surface};
    width: calc(100% + 30px);
    margin: 0 -15px;
`